<template>
    <b-card class="mb-2" header-tag="header">
        <template #header>
            <h6 class="mb-0 text-center">
                <i class="fa fa-users"></i> Referencias
            </h6>
        </template>
        <b-row>
            <b-col>
                <h6><b>Referencias Personales</b></h6>
                <hr>
            </b-col>
            <div class="w-100"></div>
            <b-col md>
                <div class="form-group">
                    <label for="">Nombre Completo</label>
                    <input
                        type="text"
                        class="form-control"
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Celular</label>
                    <input
                        type="text"
                        class="form-control"
                    />
                </div>
            </b-col>
             <b-col md>
                <div class="form-group">
                    <label for="">Dirección</label>
                    <input
                        type="text"
                        class="form-control"
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Ciudad</label>
                    <input
                        type="text"
                        class="form-control"
                    />
                </div>
            </b-col>
             <div class="w-100"></div>
            <b-col md>
                <div class="form-group">
                    <label for="">Nombre Completo</label>
                    <input
                        type="text"
                        class="form-control"
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Celular</label>
                    <input
                        type="text"
                        class="form-control"
                    />
                </div>
            </b-col>
             <b-col md>
                <div class="form-group">
                    <label for="">Dirección</label>
                    <input
                        type="text"
                        class="form-control"
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Ciudad</label>
                    <input
                        type="text"
                        class="form-control"
                    />
                </div>
            </b-col>
        </b-row>
         <b-row>
            <b-col>
                <h6><b>Referencias Familiares</b></h6>
                <hr>
            </b-col>
            <div class="w-100"></div>
            <b-col md>
                <div class="form-group">
                    <label for="">Nombre Completo</label>
                    <input
                        type="text"
                        class="form-control"
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Celular</label>
                    <input
                        type="text"
                        class="form-control"
                    />
                </div>
            </b-col>
             <b-col md>
                <div class="form-group">
                    <label for="">Dirección</label>
                    <input
                        type="text"
                        class="form-control"
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Ciudad</label>
                    <input
                        type="text"
                        class="form-control"
                    />
                </div>
            </b-col>
             <div class="w-100"></div>
            <b-col md>
                <div class="form-group">
                    <label for="">Nombre Completo</label>
                    <input
                        type="text"
                        class="form-control"
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Celular</label>
                    <input
                        type="text"
                        class="form-control"
                    />
                </div>
            </b-col>
             <b-col md>
                <div class="form-group">
                    <label for="">Dirección</label>
                    <input
                        type="text"
                        class="form-control"
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Ciudad</label>
                    <input
                        type="text"
                        class="form-control"
                    />
                </div>
            </b-col>
        </b-row>
         <b-row>
            <b-col>
                <h6><b>Referencias Comerciales</b></h6>
                <hr>
            </b-col>
            <div class="w-100"></div>
            <b-col md>
                <div class="form-group">
                    <label for="">Nombre Completo</label>
                    <input
                        type="text"
                        class="form-control"
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Celular</label>
                    <input
                        type="text"
                        class="form-control"
                    />
                </div>
            </b-col>
             <b-col md>
                <div class="form-group">
                    <label for="">Dirección</label>
                    <input
                        type="text"
                        class="form-control"
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Ciudad</label>
                    <input
                        type="text"
                        class="form-control"
                    />
                </div>
            </b-col>
             <div class="w-100"></div>
            <b-col md>
                <div class="form-group">
                    <label for="">Nombre Completo</label>
                    <input
                        type="text"
                        class="form-control"
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Celular</label>
                    <input
                        type="text"
                        class="form-control"
                    />
                </div>
            </b-col>
             <b-col md>
                <div class="form-group">
                    <label for="">Dirección</label>
                    <input
                        type="text"
                        class="form-control"
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Ciudad</label>
                    <input
                        type="text"
                        class="form-control"
                    />
                </div>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
